module.exports = __webpack_public_path__ + "static/img/8.0a4ac41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/8.jpg
// module id = 4VzL
// module chunks = 21